import { render, staticRenderFns } from "./page-header-v2.vue?vue&type=template&id=5f962a29&"
import script from "./page-header-v2.vue?vue&type=script&lang=js&"
export * from "./page-header-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports